<template>
  <footer class="powered-by-mobi-footer" v-bind="$attrs">
    <div class="logo-alignment">
      <span> <strong> Singapore Trip Planner</strong> is powered by <a href="https://www.takemobi.com">Mobi Systems</a></span>
    </div>
    <slot>
      <ul class="url-list">
        <li><a href="#" @click.prevent="onShowFAQ">FAQs</a></li>
        <li><a href="#" @click.prevent="onShowTC" ref="tc">Terms of Use</a></li>
        <li><a thref="#" @click.prevent="onShowPP">Privacy Policy</a></li>
        <li><a thref="#" @click.prevent="onShowFB">Share Your Feedback</a></li>
      </ul>
    </slot>
  </footer>
</template>

<script>
import TCModal from './modal/terms-and-conditions.vue';
import FAQModal from './modal/faq-modal.vue';
import PPModal from './modal/privacy-policy-modal.vue';
import FBModal from '@common/survey/survey-modal.vue';
// @ts-ignore
import MdModalDialog from 'vue-material-modal-dialog';
import 'vue-material-modal-dialog/dist/components.css';
// @ts-ignore
import {MdDialog} from 'vue-material/dist/components';
import Vue from 'vue';

Vue.use(MdDialog);
Vue.use(MdModalDialog);

export default {
  methods: {
    onShowTC() {
      const app = document.querySelector('#app');
      app.inert = true;
      this.$modal
        .show(TCModal, {})
        .catch(() => null)
        .finally(() => {
          app.inert = false;
          this.$refs.tc.focus();
        });
    },

    onShowFAQ() {
      const app = document.querySelector('#app');
      app.inert = true;
      this.$modal
        .show(FAQModal, {})
        .catch(() => null)
        .finally(() => {
          app.inert = false;
          this.$refs.tc.focus();
        });
    },
    onShowPP() {
      const app = document.querySelector('#app');
      app.inert = true;
      this.$modal
        .show(PPModal, {})
        .catch(() => null)
        .finally(() => {
          app.inert = false;
          this.$refs.tc.focus();
        });
    },
    onShowFB() {
      const app = document.querySelector('#app');
      app.inert = true;
      this.$modal
        .show(FBModal, {})
        .catch(() => null)
        .finally(() => {
          app.inert = false;
          this.$refs.tc.focus();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.powered-by-mobi-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid #ecedee;
  justify-content: center;
  padding: 35px 20px;
  max-width: var(--page-container-width, 1240px);
  margin: 0 auto;
}

.footer-alignment {
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: wrap;
  align-items: stretch;
}

.logo-alignment {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.logo-a {
  position: relative;
  top: 3px;
}
.logo-alignment > span {
  margin-right: 0.5em;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #737373;
  // opacity: 0.6;
}

.url-list {
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;

  & li {
    padding: 0 10px;
  }

  & a {
    padding: 5px 1px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: var(--btn-primary-color, hsl(208, 100%, 41%));
    &:hover {
      cursor: pointer;
    }
  }

  & > li + li {
    border-left: 1px solid #c3c3c3;
  }
}

@media screen and (min-width: 850px) {
  .url-list {
    margin-left: auto;
    margin-top: 0;
    margin-bottom: 0;
  }

  .footer-alignment {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
